import { render, staticRenderFns } from "./PivotTotalsTab.vue?vue&type=template&id=02a1a11b&scoped=true"
import script from "./PivotTotalsTab.vue?vue&type=script&lang=js"
export * from "./PivotTotalsTab.vue?vue&type=script&lang=js"
import style0 from "./PivotTotalsTab.vue?vue&type=style&index=0&id=02a1a11b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a1a11b",
  null
  
)

export default component.exports